module.exports = __webpack_public_path__ + "img/feature_buy_th.fcd2b311.png";